import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        "& > *": {
            margin: theme.spacing(0.5),
        },
    },
}));

const LabelEstatusPaquete = (props) => {
    const { Estatus, Descipcion } = props;
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Chip
                variant="outlined"
                color={ (Estatus === 1) ? "secondary" : "default" }
                label={ (Estatus === 1) ? "Activo" : Descipcion}
            />
        </div>
    );
};
export default LabelEstatusPaquete;
